import React from 'react';
import { AlertTriangle, Info, Scale } from 'lucide-react';

const PublicNoticeDisclosure = ({ variant = 'default' }) => {
  // Different styling variants for different pages
  const getVariantStyles = () => {
    switch (variant) {
      case 'compact':
        return {
          container: 'bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4 mb-6',
          title: 'text-sm font-semibold text-amber-800',
          content: 'text-xs text-amber-700 leading-relaxed',
          icon: 'w-4 h-4 text-amber-600'
        };
      case 'prominent':
        return {
          container: 'bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-2 border-blue-200 rounded-xl p-8 mb-8 shadow-lg',
          title: 'text-xl font-bold text-blue-900',
          content: 'text-sm text-blue-800 leading-relaxed',
          icon: 'w-6 h-6 text-blue-600'
        };
      default:
        return {
          container: 'bg-gradient-to-r from-yellow-50 to-amber-50 border border-yellow-200 rounded-lg p-6 mb-6',
          title: 'text-lg font-semibold text-yellow-800',
          content: 'text-sm text-yellow-700 leading-relaxed',
          icon: 'w-5 h-5 text-yellow-600'
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div className={styles.container}>
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 mt-1">
          <Scale className={styles.icon} />
        </div>
        <div className="flex-1">
          <h3 className={`${styles.title} mb-3 flex items-center`}>
            <Info className="w-4 h-4 mr-2" />
            PUBLIC NOTICE DISCLOSURE
          </h3>
          <div className={styles.content}>
            <p className="mb-4">
              This Notice is hereby published by the undersigned in the capacity of a <strong>Private Living Man or Woman</strong>, 
              acting outside of any commercial, corporate, or statutory jurisdiction, and not as a surety, agent, or representative 
              of any fiction or entity. This Notice is made publicly available on the TheEqualizer.AI platform for the purpose 
              of establishing lawful notice to all parties, under the principles of:
            </p>
            
            <p className="mb-4">
              <strong>• Due Process of Law • Good Faith and Fair Dealing • The Right to Petition for Redress • The Doctrine of Estoppel by Silence</strong>
            </p>

            <p className="mb-4">
              All declarations, rebuttals, and affirmations posted herein are executed under <strong>Common Law</strong>, 
              <strong>Equity Jurisprudence</strong>, and where applicable, under the protections of Natural, Constitutional, 
              and International Law. Unless otherwise rebutted in kind, with verified evidence and within the timeframe 
              prescribed (if stated), all contents of this Notice shall stand as:
            </p>

            <p className="mb-4">
              <strong>True, Correct, Complete, and Binding upon the parties to whom it concerns</strong>
            </p>

            <p className="font-medium">
              This Notice is not a threat, it is a peaceful act of lawful record and public affirmation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicNoticeDisclosure;